import request from './request'

export function getMyParticipatedCases(data) {
    return request({
        url: '/api/case/getMyParticipatedCases',
        method: 'get',
        params: data
    })
}